// 节假日配置
import request from "@/utils/interceptor.js";

const activityApi = {
  // 获取列表
  getActivityList(params) {
    return request({
      url: `/api/pas/activity`,
      method: "get",
      params,
    });
  },
  addActivity(data) {
    return request({
      url: `/api/pas/activity`,
      method: "post",
      data,
    });
  },
  editActivity(data) {
    return request({
      url: `/api/pas/activity/${data.id}`,
      method: "put",
      data,
    });
  },
  delActivity(id) {
    return request({
      url: `/api/pas/activity/${id}`,
      method: "delete",
    });
  },
  // 设备绑定活动
  bindActivity(data) {
    return request({
      url: `/api/pas/device-code`,
      method: "post",
      data,
    });
  },
  editBindActivity(data) {
    return request({
      url: `/api/pas/device-code/${data.id}`,
      method: "put",
      data,
    });
  }
};

export default activityApi;
